import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function SectionNav({ items, navKey = "nav" }) {
    const [active, setActive] = useState(items[0]?.id);

    useEffect(() => {
        const onScroll = () => {
            const marker = 150;
            let current = items[0]?.id;
            for (const it of items) {
                const el = document.getElementById(it.id);
                if (el && el.getBoundingClientRect().top - marker <= 0) current = it.id;
            }
            if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
                current = items[items.length - 1]?.id;
            }
            setActive(current);
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll);
        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", onScroll);
        };
    }, [items]);

    const go = (id) => (e) => {
        e.preventDefault();
        const el = document.getElementById(id);
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -136 });
        else el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <nav
            aria-label="Section navigation"
            data-testid="section-nav"
            className="sticky top-20 z-30 hidden border-b border-line bg-paper/95 backdrop-blur-md lg:block"
        >
            <div className="container-x flex items-center overflow-x-auto">
                {items.map((it, i) => (
                    <a
                        key={it.id}
                        href={`#${it.id}`}
                        onClick={go(it.id)}
                        aria-current={active === it.id ? "location" : undefined}
                        data-testid={`section-nav-${it.id}`}
                        className={`relative whitespace-nowrap py-4 pr-6 pl-6 font-mono text-[11px] uppercase tracking-[0.18em] transition-colors first:pl-0 ${
                            active === it.id ? "text-blue" : "text-ink-3 hover:text-ink"
                        } ${i > 0 ? "before:absolute before:left-0 before:top-1/2 before:h-3 before:w-px before:-translate-y-1/2 before:bg-line-2" : ""}`}
                    >
                        <span className={`mr-2 ${active === it.id ? "text-blue/70" : "text-ink-3/60"}`}>
                            {String(i + 1).padStart(2, "0")}
                        </span>
                        {it.label}
                        {active === it.id && (
                            <motion.span
                                layoutId={`section-nav-underline-${navKey}`}
                                className="absolute inset-x-0 -bottom-px h-0.5 bg-blue"
                                transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                            />
                        )}
                    </a>
                ))}
            </div>
        </nav>
    );
}
